/**
 * Shared visual tokens + global keyframes for the learner AI takeaway takeover.
 *
 * The takeaway is a deliberately distinct "celebration moment" styled after the
 * NovoEd "Chizzy" playful brand language (saturated color fields, rounded
 * display type, ticket cards, claymorphism icon badges). It intentionally does
 * not match the rest of the in-app chrome.
 */
import { css } from '@emotion/react';

export const ltColors = {
  navy: '#14123A',
  yellow: '#F6E15C',
  pink: '#E0407A',
  periwinkle: '#5B6BE8',
  mint: '#7FE0C9',
  green: '#2BB673',
  white: '#FFFFFF',
};

/** Rounded display stack; Fredoka is loaded via the Global block below. */
export const ltFont = "'Fredoka', 'Baloo 2', 'Quicksand', 'Open Sans', sans-serif";

export const ltGlobalStyles = css`
  @import url('https://fonts.googleapis.com/css2?family=Fredoka:wght@400;500;600;700&display=swap');

  @keyframes ltPop {
    0% { transform: scale(0) rotate(-14deg); }
    70% { transform: scale(1.18) rotate(6deg); }
    100% { transform: scale(1) rotate(0); }
  }
  @keyframes ltFloat {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-8px); }
  }
  @keyframes ltPulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.12); }
  }
  @keyframes ltSpin {
    0% { transform: rotate(0); }
    100% { transform: rotate(360deg); }
  }
  @keyframes ltRing {
    0%, 100% { box-shadow: 0 0 0 0 rgba(224, 64, 122, 0.5); }
    50% { box-shadow: 0 0 0 8px rgba(224, 64, 122, 0); }
  }

  .lt-step {
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 0.6s ease, transform 0.6s ease;
  }
  .lt-step.lt-in {
    opacity: 1;
    transform: none;
  }
  .lt-badge { transform: scale(0); }
  .lt-step.lt-in .lt-badge { animation: ltPop 0.6s cubic-bezier(0.2, 1.4, 0.4, 1) forwards; }

  @media (prefers-reduced-motion: reduce) {
    .lt-step { transition: none; opacity: 1; transform: none; }
    .lt-badge { transform: none; }
  }
`;
